import { ChangeEvent } from "react"
import { StyledLabel } from "components/input/style"

export type LabeledNativeSelectOption = {
  value: string
  label: string
}

type Props = {
  label?: string
  value: string
  onChange: (ev: ChangeEvent<HTMLSelectElement>) => void
  options: LabeledNativeSelectOption[]
  placeholderOption?: LabeledNativeSelectOption
  disabled?: boolean
  className?: string
  selectClassName?: string
}

export const Dropdown = ({
  label,
  value,
  onChange,
  options,
  placeholderOption,
  disabled,
  className,
  selectClassName,
}: Props) => {
  const baseSelect =
    selectClassName ?? "w-full border border-slate-300 rounded p-2 mt-2 text-sm"

  return (
    <div className={className}>
      {label ? <StyledLabel>{label}</StyledLabel> : null}
      <select
        className={baseSelect}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {placeholderOption ? (
          <option value={placeholderOption.value}>{placeholderOption.label}</option>
        ) : null}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  )
}
